module.exports = __webpack_public_path__ + "img/Hero@3x.ec6c2a40.png";